import { Box } from '@mui/material';
import { plPL } from '@mui/x-data-grid';
import { DataGridPro } from '@mui/x-data-grid-pro';
import React from 'react';
import { DataGridToolbar } from '../../../components/data-grid/DataGridToolbar';
import Scrollbar from '../../../components/Scrollbar';
import { dynamicSectionsColumns } from '../../../services/column-definitions';
import DynamicSectionsUpdateCreate from './DynamicSectionsUpdateCreate';

export default function DynamicSectionsList({
  dynamicSections,
  queryCallback,
  setDynamicSections
}) {
  const [search, setSearch] = React.useState(null);
  const [form, setForm] = React.useState({});
  const [openEditModal, setOpenEditModal] = React.useState(false);

  const handleOpenEditModal = row => {
    setForm(row);
    setOpenEditModal(true);
  };

  const searchCallback = search => {
    queryCallback(search);
  };

  return (
    <>
      <Scrollbar>
        <Box sx={{ minWidth: { md: 800 }, m: 4 }}>
          <DataGridPro
            columns={dynamicSectionsColumns(handleOpenEditModal)}
            rows={dynamicSections}
            density="standard"
            disableColumnMenu={true}
            autoPageSize={false}
            autoHeight={true}
            rowsPerPageOptions={[10, 25, 50, 100]}
            pagination
            components={{
              Toolbar: DataGridToolbar
            }}
            componentsProps={{ toolbar: { miniView: true, searchCallback } }}
            localeText={plPL.components.MuiDataGrid.defaultProps.localeText}
            disableSelectionOnClick
          />
        </Box>
        {openEditModal ? (
          <DynamicSectionsUpdateCreate
            open={openEditModal}
            setOpen={setOpenEditModal}
            form={form}
            setDynamicSections={setDynamicSections}
          />
        ) : null}
      </Scrollbar>
    </>
  );
}
